import ModelFactory from "./factory";
import ObjectHelper from "src/util/objectHelper";
import collect from "collect.js";

export default class Deserializer {
  constructor(model, data) {
    this.model = ObjectHelper.cloneClass(model);
    this.data = data;
  }

  /**
   * Método realiza deserialização de dados
   * @param include
   * @returns {any|*}
   */
  deserialize(include = []) {
    this._fillPrimaryKey();
    this._fillAttributes();
    this._fillMeta();
    this._fillRelationships(include);

    return this.model;
  }

  /**
   * Método preenche a chave primária da model
   * @private
   */
  _fillPrimaryKey() {
    if (this.model.primaryKey() in this.data) {
      this.model.id = this.data.id;
    }
  }

  /**
   * Método preenche os atributos da model
   * @private
   */
  _fillAttributes() {
    let attributes =
      this.model.fields() === "*" ? this.data.attributes : this.model.fields();

    for (let field in attributes) {
      if (field in this.data.attributes) {
        this.model[field] = this.data.attributes[field];
      }
    }
  }

  /**
   * Método preenche os metadados da model
   * @private
   */
  _fillMeta() {
    this.model._meta = {
      links: this.data.links,
      relationships: this.data.relationships || {},
      type: this.data.type,
      data: this.data.meta
    };
  }

  /**
   * Método preenche os relacionamentos da model
   * @param include
   * @private
   */
  _fillRelationships(include) {
    if (include.length === 0) {
      return;
    }

    for (let relationship in this.model._meta.relationships) {
      if (relationship === "companies") {
        this._hydrateRelationship(relationship, include);
      }
      if (this.model._meta.relationships.hasOwnProperty(relationship)) {
        this._hydrateRelationship(relationship, include);
      }
    }
  }

  /**
   * Método acessa referência para chamar função que itera os included
   * @param relationship
   * @param include
   * @private
   */
  _hydrateRelationship(relationship, include) {
    let relationshipData = this.model._meta.relationships[relationship].data;
    // Adiciona relacionamentos 1-1
    if (Array.isArray(relationshipData) === false) {
      this._setRelationDataByReferences(
        relationship,
        relationshipData,
        include
      );
      return;
    }

    // Itera cada registro de referência a relacionamento
    this.model[relationship] = [];
    relationshipData.forEach(references =>
      this._setRelationDataByReferences(relationship, references, include)
    );
  }

  /**
   * Método preenche os dados de um relacionamento
   * @param relationship
   * @param reference
   * @param include
   * @private
   */
  _setRelationDataByReferences(relationship, reference, include) {
    let data = this._findRelatedDataByReference(reference, include);
    if (data) {
      let related = ModelFactory.instantiateByResourceName(
        reference.type,
        data,
        include
      );
      this._addRelatedToModel(relationship, related);
    }
  }

  /**
   * Método altera propriedade de relacionamento da model
   * @param relationship
   * @param related
   * @private
   */
  _addRelatedToModel(relationship, related) {
    if (Array.isArray(this.model[relationship])) {
      this.model[relationship].push(related);
      return;
    }

    this.model[relationship] = related;
  }

  /**
   * Método encontra os dados de um relacionamento por sua referência
   * @param reference
   * @param include
   * @returns {any}
   * @private
   */
  _findRelatedDataByReference(reference, include) {
    let relatedModelsData = collect(include);

    if (!reference) {
      return null;
    }

    for (let property in reference) {
      if (reference.hasOwnProperty(property)) {
        let value = reference[property];

        relatedModelsData = relatedModelsData.where(property, value);
      }
    }

    return relatedModelsData.first();
  }
}
